import http from '../http'

export function info()
{
    return http.get('user/user')
}